import { IUser } from "@typed/User";
import { getTokenAndId } from "@contexts/AuthContext/functions/getAuthToken";
import { UserOutputSchema } from "../schemas/user";

export const GetUser = async (): Promise<IUser | null> => {
  const { token: authToken, userId } = await getTokenAndId();
  if (!authToken) throw new Error("Couldn't get Auth Token. Make sure you're logged in.");

  // Send the product replacement request
  const response = await fetch(`${process.env.GATSBY_GAC_API4_URI}/user/${userId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: authToken,
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Request failed with status: ${response.status} - ${response.statusText}. Server response: ${errorText}`);
  }

  const user: IUser = UserOutputSchema.parse(await response.json());

  return user;
};
